// jshint esversion: 8

export default {
  distinctive: {
    _id: null,
    name: null,
    coachManagerSerialNumber: null,
    companySerialNumber: null,
  }
};
